'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/peripheral", "/peripheral/list");

  $stateProvider
    .state('peripheral', {
      url: '/peripheral',
      template: require('./peripheral.html'),
      authenticate: true
    })
    .state('peripheral.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'PeripheralListController',
      controllerAs: 'pListCtrl'
    })
    .state('peripheral.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'PeripheralShowController',
      controllerAs: 'pShowCtrl'
    })
    .state('peripheral.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'PeripheralAddController',
      controllerAs: 'pAddCtrl'
    })
    .state('peripheral.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'PeripheralEditController',
      controllerAs: 'pEditCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/peripheral/peripheral.routes.js